import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { browserHistory } from 'react-router';
import get from 'lodash/get';
import Bem from 'bemHelper';
import { I18nHoc } from 'helpers/i18n';
import cacheTerms from 'helpers/cacheTerms';
import preload from 'api/data-preload';
import Dict from 'api/data-dict';
import seoPreload, { seoDecorator } from 'api/seo';
import DataProvider from 'api/data-provider';
// import GeoLandings from 'subsys/geo-landings';
import { marketStatEvents, mstatDecorator } from 'subsys/market-stat';
import { SeoText } from 'components/layouts';
import Container from 'components/container';
import Row, { Col } from 'components/row';
import Button from 'components/button';
import { iconTypes } from 'components/icon';
import Breadcrumbs from 'components/breadcrumbs';

import linksBildControl from 'src-sites/bildcontrol/links';

import HowWeCalculateBlock from './blocks/block-how-we-calculate';
import MoreAboutRIBlock from './blocks/block-more-about-RI';
import HowExpertWorksBlock from './blocks/block-how-expert-works';
import ExpertMustConfirmBlock from './blocks/block-expert-must-confirm';
import WhatsInReportBlock from './blocks/block-whats-in-report';
import AnalysisRegisterCourtDecisionsBlock from './blocks/block-analysis-register-court-decisions';
import LegalAdviceContractAnalysisBlock from './blocks/block-legal-advice-contract-analysis';
import ReputationDeveloperBlock from './blocks/block-reputation-developer';
import AcquireReliabilityReportsBlock from './blocks/block-acquire-reliability-reports';
import ImportantBlock from './blocks/block-important';
// import WeStudyBlock from './blocks/block-we-study';
// import CheckDocumentsBlock from './blocks/check-documents-block';

import translates from './how-we-calculate-score-i18n';

import 'styles/bildcontrol/section-how-we-calculate-score/_page-how-we-calculate.scss';

const classes = new Bem('pageHowWeCalculate');
const classesBemToBack = new Bem('toBack');

@preload({
  topProjects: [DataProvider.preload, {
    url: 'bild/newbuilds-list',
    queryJson: true,
    query: { order: ['pointsLevel', 'desc'], limit: 1, onlyReliability: true },
    cache: cacheTerms.longInfoProvider
  }],
  // billProducts: [DataProvider.preload, {
  //   url: 'core/billing/bill-products-list',
  //   cache: cacheTerms.standartInfoProvider
  // }],
  livingComplexCondition: [Dict.preload, { url: 'reliability/living-complex' }],
  developerCondition: [Dict.preload, { url: 'reliability/developer' }],
  ...seoPreload({ entity: 'howWeCalculate' }, [])
})
@seoDecorator({
  advancedVars: {
    bottomText: 'Текст в самом низу'
  }
})
@mstatDecorator(marketStatEvents.historyChange, () => ({ entity: 'Как мы считаем оценку' }))
@I18nHoc(translates())
export default class PageHowWeCalculateScore extends Component {
  static propTypes = {
    className: PropTypes.string,
    // location: PropTypes.shape({}),
    seoData: PropTypes.shape({}),
    // mainMenuBase: PropTypes.shape({}),
    // billProducts: PropTypes.shape({}),
    livingComplexCondition: PropTypes.shape({}),
    developerCondition: PropTypes.shape({}),
    topProjects: PropTypes.shape({})
  };

  constructor(...args) {
    super(...args);

    this.state = {
      mounted: false
    };
  }

  componentDidMount() {
    this.setState({mounted: true});
  }

  renderToBack = () => {
    const { i18n } = this;

    return (
      <div {...classesBemToBack()}>
        <Row {...classesBemToBack('row')}>
          <Col {...classesBemToBack('col')} allFlex allColumn allPr={0}>
            {this.state.mounted &&
            browserHistory &&
            browserHistory.goBack &&
            window.history.length > 1 &&
              <Button
                {...classesBemToBack('btn', 'toBack')}
                onClick={browserHistory.goBack}
                label={i18n('btnToBackText')}
                title={i18n('btnToBackTitle')}
                iconType={iconTypes.arrowLeft}
              />
            }
          </Col>
        </Row>
      </div>
    );
  };

  render() {
    const { i18n } = this;
    const {
      className, seoData, // location, mainMenuBase, billProducts,
      livingComplexCondition = {}, developerCondition = {}, topProjects = {}
    } = this.props;
    const dataLC = livingComplexCondition.data || [];
    const dataDeveloper = developerCondition.data || [];
    const countCondition = dataLC.length + dataDeveloper.length;
    // const seoLocation = get(location, 'pathname');
    const seoText = get(seoData, 'bottomText');
    const header = get(seoData, 'header') ? seoData.header : i18n('howWeCalculateScoreH1');
    const dataBreadcrumbs = [
      {
        name: i18n('breadcrumbsMain'),
        builder: linksBildControl.sectionBildControl,
        builderProps: { title: i18n('breadcrumbsMain') }
      }, {
        name: i18n('howWeCalculateScoreH1'),
        builder: linksBildControl.sectionHowWeCalculateScore
      }
    ];

    return (
      <div {...classes({ extra: className })}>
        <div {...classes('blockToBack')} children={this.renderToBack()} />
        <HowWeCalculateBlock
          {...classes('blockHowWeCalculate')}
          topic={header}
          countCondition={countCondition}
          topProjects={topProjects}
        />
        <MoreAboutRIBlock {...classes('blockMoreAboutRI')} />
        <HowExpertWorksBlock
          {...classes('blockHowExpertWorks')}
          countCondition={countCondition}
        />
        <ExpertMustConfirmBlock {...classes('blockExpertMustConfirm')} />
        <WhatsInReportBlock {...classes('blockWhatsInReport')} />
        <AnalysisRegisterCourtDecisionsBlock {...classes('blockAnalysisRegisterCourtDecisions')} />
        <LegalAdviceContractAnalysisBlock {...classes('blockLegalAdviceContractAnalysis')} />
        <ReputationDeveloperBlock {...classes('blockReputationDeveloper')} />
        <AcquireReliabilityReportsBlock {...classes('blockAcquireReliabilityReports')} />
        <ImportantBlock {...classes('blockImportant')} />
        {/*
        <WeStudyBlock
          {...classes('blockWeStudy')}
          livingComplexCondition={livingComplexCondition}
          developerCondition={developerCondition}
        />
        <GeoLandings
          injectPropName="mainMenu"
          base={mainMenuBase}
        >
          <CheckDocumentsBlock
            {...classes('blockCheckDocuments')}
            billProducts={billProducts}
          />
        </GeoLandings>
        */}
        <Container body>
          <Breadcrumbs {...classes('breadcrumbs')} data={dataBreadcrumbs} />
          <SeoText data={seoText} />
        </Container>
      </div>
    );
  }
}
